// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import api, { setAuthToken } from '../api';   // ← NEW

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [authError, setAuthError] = useState('');

  /* --------------------------------------------------------------
     1. When token changes → sync with Axios + validate
     -------------------------------------------------------------- */
  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        try {
          // ---- keep Axios header up-to-date ----
          setAuthToken(token);                     // ← NEW

          const decoded = jwtDecode(token);
          setUser(decoded);

          // ---- verify token with server (optional but safe) ----
          const response = await api.get('/admin/me');   // uses header now
          setUser(response.data);
          localStorage.setItem('token', token);
        } catch (err) {
          console.error('Auth error:', err);
          setAuthError('Invalid or expired token. Please log in again.');
          setUser(null);
          setToken('');
          setAuthToken(null);                    // ← NEW
          localStorage.removeItem('token');
        }
      } else {
        setUser(null);
        setAuthToken(null);                      // ← NEW
        localStorage.removeItem('token');
      }
    };

    fetchUser();
  }, [token]);

  /* --------------------------------------------------------------
     2. Login – store token + sync Axios
     -------------------------------------------------------------- */
  const login = (newToken, newUser) => {
    console.log('Login →', { newToken, newUser });
    setToken(newToken);
    setUser(newUser);
    setAuthError('');
    localStorage.setItem('token', newToken);
    setAuthToken(newToken);                     // ← NEW
  };

  /* --------------------------------------------------------------
     3. Logout – clear everything
     -------------------------------------------------------------- */
  const logout = () => {
    console.log('Logout');
    setToken('');
    setUser(null);
    setAuthError('');
    localStorage.removeItem('token');
    setAuthToken(null);                         // ← NEW
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, authError }}>
      {children}
    </AuthContext.Provider>
  );
};